// client/src/lib/notificationLinks.js
// Resolve a notification object to a safe in-app route.
//
// Why: notifications were introduced gradually, so older rows may store
// url/href in different places or point to legacy routes.

function isHttp(url) {
  return typeof url === 'string' && /^https?:\/\//i.test(url);
}

function pickFirst(...vals) {
  for (const v of vals) {
    if (typeof v === 'string' && v.trim()) return v.trim();
  }
  return '';
}

function normalizeHref(href) {
  if (!href) return '';
  let h = String(href).trim();
  if (!h) return '';
  if (isHttp(h)) return h;
  if (!h.startsWith('/')) h = '/' + h;
  return h;
}

function meta(n) {
  const d = n?.data;
  return d && typeof d === 'object' ? d : {};
}

export function getNotificationHref(n) {
  const d = meta(n);
  const type = String(n?.type || '').toLowerCase();

  // Look for stored href/url in common places
  let href = pickFirst(
    d.href,
    n?.href,
    n?.url,
    d.url,
    d.link,
    d.link_path,
    d.linkPath,
    d.path
  );
  href = normalizeHref(href);

  // Fix legacy routes we used in older jobs/notifications
  if (href) {
    href = href.replace(/\/groups\/(\d+)\/manage-auction\b/i, '/groups/$1/auction');
    // Any /groups/:id/payments* becomes /payments (route exists)
    href = href.replace(/\/groups\/(\d+)\/payments\b.*$/i, '/payments');
  }

  const bad = !href || /undefined|null|\[object Object\]/i.test(href);

  const groupId = Number(d.group_id || d.groupId || n?.group_id || 0) || null;
  const conversationId = Number(d.conversation_id || d.conversationId || 0) || null;

  if (!bad) return href;

  // Type-based fallbacks (safe routes that exist in App.js)
  if (type.includes('group_message') || type === 'group_message') {
    if (groupId) return `/messages/group/${groupId}`;
  }
  if (type.includes('dm') || type === 'dm_message' || type === 'direct_message') {
    if (conversationId) return `/messages/dm/${conversationId}`;
  }
  if (type.includes('bid') || type === 'new_bid' || type === 'outbid') {
    if (groupId) return `/groups/${groupId}`;
  }
  if (type.includes('payment')) return '/payments';
  if (type.includes('finalize')) {
    if (groupId) return `/groups/${groupId}/auction`;
  }

  if (groupId) return `/groups/${groupId}`;
  return '/notifications';
}

export function openNotification(n, navigate) {
  const href = getNotificationHref(n);
  if (isHttp(href)) window.location.href = href;
  else if (typeof navigate === 'function') navigate(href);
}
